export default __webpack_public_path__ + "static/hero_banner-598a76f5f83262add94b04c259ee040f.jpg";